import script from "./customFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./customFiles.vue?vue&type=script&setup=true&lang=js"

import "./customFiles.vue?vue&type=style&index=0&id=22ad9158&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22ad9158"]])

export default __exports__